import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormService } from "../../services/form.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	// Not used
    telephoneUrl = 'tel:00000000000';

    constructor(public formService: FormService) {
    }

    ngOnInit(): void {

    }

	public getHomeUrl() {

		return this.formService.homeUrl ?? '#';
	}

	// @TODO THIS IS FOR DEBUGGING THE THANK YOU PAGE
	public goToThankYou( e:Event ) {

		e.preventDefault();

		this.formService.formActive = ! this.formService.formActive;
	}
}
